import type {
    ComponentType
} from "react";
import AccordionPage, {
    getToc as getAccordionToc
} from "./accordion";
import AlertPage, {
    getToc as getAlertToc
} from "./alert";
import AnimatedIconPage, {
    getToc as getAnimatedIconToc
} from "./animatedIcon";
import AreaChartPage, {
    getToc as getAreaChartToc
} from "./areaChart";
import AspectRatioPage, {
    getToc as getAspectRatioToc
} from "./aspectRatio";
import AttachmentPage, {
    getToc as getAttachmentToc
} from "./attachment";
import AvatarPage, {
    getToc as getAvatarToc
} from "./avatar";
import AvatarGroupPage, {
    getToc as getAvatarGroupToc
} from "./avatarGroup";
import BadgePage, {
    getToc as getBadgeToc
} from "./badge";
import BarChartPage, {
    getToc as getBarChartToc
} from "./barChart";
import BottomSheetPage, {
    getToc as getBottomSheetToc
} from "./bottomSheet";
import BrandIconsPage, {
    getToc as getBrandIconsToc
} from "./brandIcons";
import BreadcrumbPage, {
    getToc as getBreadcrumbToc
} from "./breadcrumb";
import BubblePage, {
    getToc as getBubbleToc
} from "./bubble";
import ButtonPage, {
    getToc as getButtonToc
} from "./button";
import ButtonGroupPage, {
    getToc as getButtonGroupToc
} from "./buttonGroup";
import CardPage, {
    getToc as getCardToc
} from "./card";
import CarouselPage, {
    getToc as getCarouselToc
} from "./carousel";
import ChartPage, {
    getToc as getChartToc
} from "./chart";
import CheckBoxPage, {
    getToc as getCheckBoxToc
} from "./checkBox";
import ChipPage, {
    getToc as getChipToc
} from "./chip";
import CitationPage, {
    getToc as getCitationToc
} from "./citation";
import CodeEditorPage, {
    getToc as getCodeEditorToc
} from "./codeEditor";
import CodeViewerPage, {
    getToc as getCodeViewerToc
} from "./codeViewer";
import CollapsiblePage, {
    getToc as getCollapsibleToc
} from "./collapsible";
import ColorAreaPage, {
    getToc as getColorAreaToc
} from "./colorArea";
import ColorFieldPage, {
    getToc as getColorFieldToc
} from "./colorField";
import ColorPickerPage, {
    getToc as getColorPickerToc
} from "./colorPicker";
import ColorSliderPage, {
    getToc as getColorSliderToc
} from "./colorSlider";
import ColorSwatchPage, {
    getToc as getColorSwatchToc
} from "./colorSwatch";
import ColorSwatchPickerPage, {
    getToc as getColorSwatchPickerToc
} from "./colorSwatchPicker";
import ComboboxPage, {
    getToc as getComboboxToc
} from "./combobox";
import CommandPage, {
    getToc as getCommandToc
} from "./command";
import ComposerPage, {
    getToc as getComposerToc
} from "./composer";
import ContextMenuPage, {
    getToc as getContextMenuToc
} from "./contextMenu";
import DataTablePage, {
    getToc as getDataTableToc
} from "./dataTable";
import DateSelectorPage, {
    getToc as getDateSelectorToc
} from "./dateSelector";
import DateTimePickerPage, {
    getToc as getDateTimePickerToc
} from "./dateTimePicker";
import DateTimeSheetPage, {
    getToc as getDateTimeSheetToc
} from "./dateTimeSheet";
import DialogPage, {
    getToc as getDialogToc
} from "./dialog";
import DirectionProviderPage, {
    getToc as getDirectionProviderToc
} from "./directionProvider";
import DropdownMenuPage, {
    getToc as getDropdownMenuToc
} from "./dropdownMenu";
import EmbeddedMenuPage, {
    getToc as getEmbeddedMenuToc
} from "./embeddedMenu";
import EmptyPage, {
    getToc as getEmptyToc
} from "./empty";
import FieldPage, {
    getToc as getFieldToc
} from "./field";
import FileUploadPage, {
    getToc as getFileUploadToc
} from "./fileUpload";
import FlagPage, {
    getToc as getFlagToc
} from "./flag";
import HeaderPage, {
    getToc as getHeaderToc
} from "./header";
import HighlightButtonPage, {
    getToc as getHighlightButtonToc
} from "./highlightButton";
import HoverCardPage, {
    getToc as getHoverCardToc
} from "./hoverCard";
import IconPage, {
    getToc as getIconToc
} from "./icon";
import InputGroupPage, {
    getToc as getInputGroupToc
} from "./inputGroup";
import InputOTPPage, {
    getToc as getInputOTPToc
} from "./inputOTP";
import ItemPage, {
    getToc as getItemToc
} from "./item";
import KbdPage, {
    getToc as getKbdToc
} from "./kbd";
import LabelPage, {
    getToc as getLabelToc
} from "./label";
import LineChartPage, {
    getToc as getLineChartToc
} from "./lineChart";
import LoadingPage, {
    getToc as getLoadingToc
} from "./loading";
import LocaleSwitcherPage, {
    getToc as getLocaleSwitcherToc
} from "./localeSwitcher";
import MainHeaderPage, {
    getToc as getMainHeaderToc
} from "./mainHeader";
import MarkdownEditorPage, {
    getToc as getMarkdownEditorToc
} from "./markdownEditor";
import MarkdownViewerPage, {
    getToc as getMarkdownViewerToc
} from "./markdownViewer";
import MarkerPage, {
    getToc as getMarkerToc
} from "./marker";
import MenuPage, {
    getToc as getMenuToc
} from "./menu";
import MenubarPage, {
    getToc as getMenubarToc
} from "./menubar";
import MessagePage, {
    getToc as getMessageToc
} from "./message";
import MessageScrollerPage, {
    getToc as getMessageScrollerToc
} from "./messageScroller";
import ModalPage, {
    getToc as getModalToc
} from "./modal";
import MonthSelectorPage, {
    getToc as getMonthSelectorToc
} from "./monthSelector";
import NativeSelectPage, {
    getToc as getNativeSelectToc
} from "./nativeSelect";
import NavigationMenuPage, {
    getToc as getNavigationMenuToc
} from "./navigationMenu";
import NotificationIndicatorPage, {
    getToc as getNotificationIndicatorToc
} from "./notificationIndicator";
import NumericInputPage, {
    getToc as getNumericInputToc
} from "./numericInput";
import PageContainerPage, {
    getToc as getPageContainerToc
} from "./pageContainer";
import PaginationPage, {
    getToc as getPaginationToc
} from "./pagination";
import PaletteSwitcherPage, {
    getToc as getPaletteSwitcherToc
} from "./paletteSwitcher";
import PieChartPage, {
    getToc as getPieChartToc
} from "./pieChart";
import PopoverPage, {
    getToc as getPopoverToc
} from "./popover";
import ProgressPage, {
    getToc as getProgressToc
} from "./progress";
import QuestionnairePage, {
    getToc as getQuestionnaireToc
} from "./questionnaire";
import RadarChartPage, {
    getToc as getRadarChartToc
} from "./radarChart";
import RadialChartPage, {
    getToc as getRadialChartToc
} from "./radialChart";
import RadioButtonPage, {
    getToc as getRadioButtonToc
} from "./radioButton";
import RadioGroupPage, {
    getToc as getRadioGroupToc
} from "./radioGroup";
import ResizablePage, {
    getToc as getResizableToc
} from "./resizable";
import RowCardPage, {
    getToc as getRowCardToc
} from "./rowCard";
import ScrollAreaPage, {
    getToc as getScrollAreaToc
} from "./scrollArea";
import SelectBoxPage, {
    getToc as getSelectBoxToc
} from "./selectBox";
import SelectSheetPage, {
    getToc as getSelectSheetToc
} from "./selectSheet";
import SeparatorPage, {
    getToc as getSeparatorToc
} from "./separator";
import SheetPage, {
    getToc as getSheetToc
} from "./sheet";
import SidebarPage, {
    getToc as getSidebarToc
} from "./sidebar";
import SiteLogoPage, {
    getToc as getSiteLogoToc
} from "./siteLogo";
import SkeletonPage, {
    getToc as getSkeletonToc
} from "./skeleton";
import SliderPage, {
    getToc as getSliderToc
} from "./slider";
import SnackBarPage, {
    getToc as getSnackBarToc
} from "./snackBar";
import SparklinePage, {
    getToc as getSparklineToc
} from "./sparkline";
import StateCardPage, {
    getToc as getStateCardToc
} from "./stateCard";
import StatTilePage, {
    getToc as getStatTileToc
} from "./statTile";
import StepperPage, {
    getToc as getStepperToc
} from "./stepper";
import StickerPage, {
    getToc as getStickerToc
} from "./sticker";
import SwipeableRowPage, {
    getToc as getSwipeableRowToc
} from "./swipeableRow";
import SystemToolbarPage, {
    getToc as getSystemToolbarToc
} from "./systemToolbar";
import TabBarPage, {
    getToc as getTabBarToc
} from "./tabBar";
import TablePage, {
    getToc as getTableToc
} from "./table";
import TabsPage, {
    getToc as getTabsToc
} from "./tabs";
import TextPage, {
    getToc as getTextToc
} from "./text";
import TextAreaInputPage, {
    getToc as getTextAreaInputToc
} from "./textAreaInput";
import TextInputPage, {
    getToc as getTextInputToc
} from "./textInput";
import ThemeSwitcherPage, {
    getToc as getThemeSwitcherToc
} from "./themeSwitcher";
import TimelinePage, {
    getToc as getTimelineToc
} from "./timeline";
import TimeSelectorPage, {
    getToc as getTimeSelectorToc
} from "./timeSelector";
import ToastPage, {
    getToc as getToastToc
} from "./toast";
import TogglePage, {
    getToc as getToggleToc
} from "./toggle";
import ToggleGroupPage, {
    getToc as getToggleGroupToc
} from "./toggleGroup";
import TooltipPage, {
    getToc as getTooltipToc
} from "./tooltip";
import TracePage, {
    getToc as getTraceToc
} from "./trace";
import TreeViewPage, {
    getToc as getTreeViewToc
} from "./treeView";
import UserShortcutPage, {
    getToc as getUserShortcutToc
} from "./userShortcut";
import WebScrollbarPage, {
    getToc as getWebScrollbarToc
} from "./webScrollbar";
import YearSelectorPage, {
    getToc as getYearSelectorToc
} from "./yearSelector";
import type {
    DocsTranslate
} from "../../anatomy/types";
import type {
    DocsTocItem
} from "../../components/toc";
import SwitchPage, {
    getSwitchToc
} from "../switchPage";

export type ComponentPageEntry = {
    getToc: (t: DocsTranslate) => Array<DocsTocItem>;
    Page: ComponentType;
};

export const COMPONENT_PAGES: Record<string, ComponentPageEntry> = {
    NotificationIndicator: {
        getToc: getNotificationIndicatorToc,
        Page: NotificationIndicatorPage
    },
    ColorSwatchPicker: {
        getToc: getColorSwatchPickerToc,
        Page: ColorSwatchPickerPage
    },
    DirectionProvider: {
        getToc: getDirectionProviderToc,
        Page: DirectionProviderPage
    },
    HighlightButton: {
        getToc: getHighlightButtonToc,
        Page: HighlightButtonPage
    },
    MessageScroller: {
        getToc: getMessageScrollerToc,
        Page: MessageScrollerPage
    },
    PaletteSwitcher: {
        getToc: getPaletteSwitcherToc,
        Page: PaletteSwitcherPage
    },
    DateTimePicker: {
        getToc: getDateTimePickerToc,
        Page: DateTimePickerPage
    },
    LocaleSwitcher: {
        getToc: getLocaleSwitcherToc,
        Page: LocaleSwitcherPage
    },
    MarkdownEditor: {
        getToc: getMarkdownEditorToc,
        Page: MarkdownEditorPage
    },
    MarkdownViewer: {
        getToc: getMarkdownViewerToc,
        Page: MarkdownViewerPage
    },
    NavigationMenu: {
        getToc: getNavigationMenuToc,
        Page: NavigationMenuPage
    },
    DateTimeSheet: {
        getToc: getDateTimeSheetToc,
        Page: DateTimeSheetPage
    },
    MonthSelector: {
        getToc: getMonthSelectorToc,
        Page: MonthSelectorPage
    },
    PageContainer: {
        getToc: getPageContainerToc,
        Page: PageContainerPage
    },
    Questionnaire: {
        getToc: getQuestionnaireToc,
        Page: QuestionnairePage
    },
    SystemToolbar: {
        getToc: getSystemToolbarToc,
        Page: SystemToolbarPage
    },
    TextAreaInput: {
        getToc: getTextAreaInputToc,
        Page: TextAreaInputPage
    },
    ThemeSwitcher: {
        getToc: getThemeSwitcherToc,
        Page: ThemeSwitcherPage
    },
    AnimatedIcon: {
        getToc: getAnimatedIconToc,
        Page: AnimatedIconPage
    },
    DateSelector: {
        getToc: getDateSelectorToc,
        Page: DateSelectorPage
    },
    DropdownMenu: {
        getToc: getDropdownMenuToc,
        Page: DropdownMenuPage
    },
    EmbeddedMenu: {
        getToc: getEmbeddedMenuToc,
        Page: EmbeddedMenuPage
    },
    NativeSelect: {
        getToc: getNativeSelectToc,
        Page: NativeSelectPage
    },
    NumericInput: {
        getToc: getNumericInputToc,
        Page: NumericInputPage
    },
    SwipeableRow: {
        getToc: getSwipeableRowToc,
        Page: SwipeableRowPage
    },
    TimeSelector: {
        getToc: getTimeSelectorToc,
        Page: TimeSelectorPage
    },
    UserShortcut: {
        getToc: getUserShortcutToc,
        Page: UserShortcutPage
    },
    WebScrollbar: {
        getToc: getWebScrollbarToc,
        Page: WebScrollbarPage
    },
    YearSelector: {
        getToc: getYearSelectorToc,
        Page: YearSelectorPage
    },
    AspectRatio: {
        getToc: getAspectRatioToc,
        Page: AspectRatioPage
    },
    AvatarGroup: {
        getToc: getAvatarGroupToc,
        Page: AvatarGroupPage
    },
    BottomSheet: {
        getToc: getBottomSheetToc,
        Page: BottomSheetPage
    },
    ButtonGroup: {
        getToc: getButtonGroupToc,
        Page: ButtonGroupPage
    },
    Collapsible: {
        getToc: getCollapsibleToc,
        Page: CollapsiblePage
    },
    ColorPicker: {
        getToc: getColorPickerToc,
        Page: ColorPickerPage
    },
    ColorSlider: {
        getToc: getColorSliderToc,
        Page: ColorSliderPage
    },
    ColorSwatch: {
        getToc: getColorSwatchToc,
        Page: ColorSwatchPage
    },
    ContextMenu: {
        getToc: getContextMenuToc,
        Page: ContextMenuPage
    },
    RadialChart: {
        getToc: getRadialChartToc,
        Page: RadialChartPage
    },
    RadioButton: {
        getToc: getRadioButtonToc,
        Page: RadioButtonPage
    },
    SelectSheet: {
        getToc: getSelectSheetToc,
        Page: SelectSheetPage
    },
    ToggleGroup: {
        getToc: getToggleGroupToc,
        Page: ToggleGroupPage
    },
    Attachment: {
        getToc: getAttachmentToc,
        Page: AttachmentPage
    },
    BrandIcons: {
        getToc: getBrandIconsToc,
        Page: BrandIconsPage
    },
    Breadcrumb: {
        getToc: getBreadcrumbToc,
        Page: BreadcrumbPage
    },
    CodeEditor: {
        getToc: getCodeEditorToc,
        Page: CodeEditorPage
    },
    CodeViewer: {
        getToc: getCodeViewerToc,
        Page: CodeViewerPage
    },
    ColorField: {
        getToc: getColorFieldToc,
        Page: ColorFieldPage
    },
    FileUpload: {
        getToc: getFileUploadToc,
        Page: FileUploadPage
    },
    InputGroup: {
        getToc: getInputGroupToc,
        Page: InputGroupPage
    },
    MainHeader: {
        getToc: getMainHeaderToc,
        Page: MainHeaderPage
    },
    Pagination: {
        getToc: getPaginationToc,
        Page: PaginationPage
    },
    RadarChart: {
        getToc: getRadarChartToc,
        Page: RadarChartPage
    },
    RadioGroup: {
        getToc: getRadioGroupToc,
        Page: RadioGroupPage
    },
    ScrollArea: {
        getToc: getScrollAreaToc,
        Page: ScrollAreaPage
    },
    Accordion: {
        getToc: getAccordionToc,
        Page: AccordionPage
    },
    AreaChart: {
        getToc: getAreaChartToc,
        Page: AreaChartPage
    },
    ColorArea: {
        getToc: getColorAreaToc,
        Page: ColorAreaPage
    },
    DataTable: {
        getToc: getDataTableToc,
        Page: DataTablePage
    },
    HoverCard: {
        getToc: getHoverCardToc,
        Page: HoverCardPage
    },
    LineChart: {
        getToc: getLineChartToc,
        Page: LineChartPage
    },
    Resizable: {
        getToc: getResizableToc,
        Page: ResizablePage
    },
    SelectBox: {
        getToc: getSelectBoxToc,
        Page: SelectBoxPage
    },
    Separator: {
        getToc: getSeparatorToc,
        Page: SeparatorPage
    },
    Sparkline: {
        getToc: getSparklineToc,
        Page: SparklinePage
    },
    StateCard: {
        getToc: getStateCardToc,
        Page: StateCardPage
    },
    TextInput: {
        getToc: getTextInputToc,
        Page: TextInputPage
    },
    BarChart: {
        getToc: getBarChartToc,
        Page: BarChartPage
    },
    Carousel: {
        getToc: getCarouselToc,
        Page: CarouselPage
    },
    CheckBox: {
        getToc: getCheckBoxToc,
        Page: CheckBoxPage
    },
    Citation: {
        getToc: getCitationToc,
        Page: CitationPage
    },
    Combobox: {
        getToc: getComboboxToc,
        Page: ComboboxPage
    },
    Composer: {
        getToc: getComposerToc,
        Page: ComposerPage
    },
    InputOTP: {
        getToc: getInputOTPToc,
        Page: InputOTPPage
    },
    PieChart: {
        getToc: getPieChartToc,
        Page: PieChartPage
    },
    Progress: {
        getToc: getProgressToc,
        Page: ProgressPage
    },
    SiteLogo: {
        getToc: getSiteLogoToc,
        Page: SiteLogoPage
    },
    Skeleton: {
        getToc: getSkeletonToc,
        Page: SkeletonPage
    },
    SnackBar: {
        getToc: getSnackBarToc,
        Page: SnackBarPage
    },
    StatTile: {
        getToc: getStatTileToc,
        Page: StatTilePage
    },
    Timeline: {
        getToc: getTimelineToc,
        Page: TimelinePage
    },
    TreeView: {
        getToc: getTreeViewToc,
        Page: TreeViewPage
    },
    Command: {
        getToc: getCommandToc,
        Page: CommandPage
    },
    Loading: {
        getToc: getLoadingToc,
        Page: LoadingPage
    },
    Menubar: {
        getToc: getMenubarToc,
        Page: MenubarPage
    },
    Message: {
        getToc: getMessageToc,
        Page: MessagePage
    },
    Popover: {
        getToc: getPopoverToc,
        Page: PopoverPage
    },
    RowCard: {
        getToc: getRowCardToc,
        Page: RowCardPage
    },
    Sidebar: {
        getToc: getSidebarToc,
        Page: SidebarPage
    },
    Stepper: {
        getToc: getStepperToc,
        Page: StepperPage
    },
    Sticker: {
        getToc: getStickerToc,
        Page: StickerPage
    },
    Tooltip: {
        getToc: getTooltipToc,
        Page: TooltipPage
    },
    Avatar: {
        getToc: getAvatarToc,
        Page: AvatarPage
    },
    Bubble: {
        getToc: getBubbleToc,
        Page: BubblePage
    },
    Button: {
        getToc: getButtonToc,
        Page: ButtonPage
    },
    Dialog: {
        getToc: getDialogToc,
        Page: DialogPage
    },
    Header: {
        getToc: getHeaderToc,
        Page: HeaderPage
    },
    Marker: {
        getToc: getMarkerToc,
        Page: MarkerPage
    },
    Slider: {
        getToc: getSliderToc,
        Page: SliderPage
    },
    Switch: {
        getToc: getSwitchToc,
        Page: SwitchPage
    },
    TabBar: {
        getToc: getTabBarToc,
        Page: TabBarPage
    },
    Toggle: {
        getToc: getToggleToc,
        Page: TogglePage
    },
    Alert: {
        getToc: getAlertToc,
        Page: AlertPage
    },
    Badge: {
        getToc: getBadgeToc,
        Page: BadgePage
    },
    Chart: {
        getToc: getChartToc,
        Page: ChartPage
    },
    Empty: {
        getToc: getEmptyToc,
        Page: EmptyPage
    },
    Field: {
        getToc: getFieldToc,
        Page: FieldPage
    },
    Label: {
        getToc: getLabelToc,
        Page: LabelPage
    },
    Modal: {
        getToc: getModalToc,
        Page: ModalPage
    },
    Sheet: {
        getToc: getSheetToc,
        Page: SheetPage
    },
    Table: {
        getToc: getTableToc,
        Page: TablePage
    },
    Toast: {
        getToc: getToastToc,
        Page: ToastPage
    },
    Trace: {
        getToc: getTraceToc,
        Page: TracePage
    },
    Card: {
        getToc: getCardToc,
        Page: CardPage
    },
    Chip: {
        getToc: getChipToc,
        Page: ChipPage
    },
    Flag: {
        getToc: getFlagToc,
        Page: FlagPage
    },
    Icon: {
        getToc: getIconToc,
        Page: IconPage
    },
    Item: {
        getToc: getItemToc,
        Page: ItemPage
    },
    Menu: {
        getToc: getMenuToc,
        Page: MenuPage
    },
    Tabs: {
        getToc: getTabsToc,
        Page: TabsPage
    },
    Text: {
        getToc: getTextToc,
        Page: TextPage
    },
    Kbd: {
        getToc: getKbdToc,
        Page: KbdPage
    }
};
